
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/>    
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3" @click="exportarPdf"/>
    <Button icon="pi pi-file" class="p-ml-2" title="Exporta para arquivo XLS" @click="exportarXls"/>
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import { exibirMensagem, exibirMensagemSis, preViewArquivo, download, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {
            dataFinal: new Date(),
            dataInicio: new Date(),
            rangeData: '',
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        exportarPdf() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {  
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal), 
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarSaldoBancoHoras(requisicao)
            .then(resp => {     
                preViewArquivo(resp.data);             
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });
        },
        exportarXls() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                idsFuncionarios: idsFuncionarios,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.exportarSaldoBancoHorasXls(requisicao)
            .then(resp => {                   
                download(resp.data, resp.headers['ik-response']);
            })
            .catch(erro => {
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });          
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    mounted() {
        this.criarRangeData();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,
    }
}
</script>

<style>

</style>